import AdyenCheckout from '@adyen/adyen-web';
import '@adyen/adyen-web/dist/adyen.css';

const startTimestamp = Math.floor(Date.now() / 1000);
const container = document.getElementById('lsadyen-dropin-container');

const url = new URL(window.location.href);
const urlParams = new URLSearchParams(url.search);

const resUrl = (urlParams.has('resURL')) ? new URL(urlParams.get('resURL')) : null;

async function init() {
    if(!resUrl) {
        return;
    }

    resUrl.searchParams.append('merchantReference', urlParams.get('merchantReference'));
    resUrl.searchParams.append('shopperLocale', urlParams.get('shopperLocale'));

    if (!urlParams.has('redirectResult')) {
        await startCheckout();

        return;
    }

    await finalizeCheckout();
}

async function startCheckout() {
    const checkout = await createAdyenCheckout();
    checkout.create('dropin').mount(container);

    const paragraphs = container.getElementsByTagName('p');

    [...paragraphs].forEach((paragraph) => {
        paragraph.style.display = 'none';
    });
}

async function finalizeCheckout() {
    const checkout = await createAdyenCheckoutAfterRedirect();

    checkout.submitDetails({details: {redirectResult: urlParams.get('redirectResult')}});
}

function createAdyenCheckout() {
    return new AdyenCheckout(
        {
            environment: container.dataset.environment,
            clientKey: container.dataset.clientKey,
            analytics: {
                enabled: false,
            },
            session: {
                id: urlParams.get('sessionId'),
                sessionData: urlParams.get('sessionData'),
            },
            onPaymentCompleted: (result) => {
                handleResult(result['resultCode']);
            },
            onError: (error) => {
                handleResult(error.name);
            },
            paymentMethodsConfiguration: {
                card: {
                    hasHolderName: true,
                    holderNameRequired: true,
                    billingAddressRequired: true,
                    data: {
                        holderName: urlParams.get('shopperName'),
                        billingAddress: {
                            street: urlParams.get('shopperStreet'),
                            houseNumberOrName: urlParams.get('shopperHouseNumber'),
                            postalCode: urlParams.get('shopperPostalCode'),
                            city: urlParams.get('shopperCity'),
                            country: urlParams.get('shopperCountry'),
                        },
                    },
                },
            },
        }
    );
}

function createAdyenCheckoutAfterRedirect() {
    return new AdyenCheckout(
        {
            session: {
                id: urlParams.get('sessionId'),
            },
            onPaymentCompleted: (result) => {
                handleResult(result['resultCode']);
            },
            onError: (error) => {
                handleResult(error.name);
            },
        }
    );
}

function handleResult(result) {
    resUrl.searchParams.append('authResult', result);

    log(result, (ready) => {
        if(ready) {
            window.location = resUrl.toString();
        }
    });
}

function log(status, callback) {
    const data = new FormData();
    data.append('status', status);
    data.append('reference', urlParams.get('merchantReference'));
    data.append('startTimestamp', `${startTimestamp}`);
    data.append('resultTimestamp', `${Math.floor(Date.now() / 1000)}`);

    makePostRequest(container.dataset.logUrl, data, (ready) => {
        if(ready) {
            callback(true);
        }
    });
}

function makePostRequest(url, data, callback) {
    const xhttp = new XMLHttpRequest();

    xhttp.onreadystatechange = function () {
        if(xhttp.readyState === 4) {
            callback(true);
        }
    };

    xhttp.open('POST', url, true);
    xhttp.send(data);
}

export default {
    init,
};
